import * as React from "react";
import { FrameTop } from "./Frame";
import {
  ConnectionIcon,
  BatteryLevelIcon,
  ExitIconV2,
  HomeIconV2,
} from "./Icon";
import * as styleSheet from "../styles";
import { Box, Button, Image, Icon } from "@enaep-ng/benchmark";
import { VersionV2 } from "./Version";
import { HeaderProps } from "../types";
import englishIcon from "../img/english-arrow.svg";
import spanishIcon from "../img/spanish-arrow.svg";

const Header = (props: HeaderProps) => {
  const [isEnglish, setIsEnglish] = React.useState(true);

  const versionColorIndex = (currentVersion: any) => {
    return currentVersion.replace(/\.|MS|-/g, "") % 16;
  };

  return (
    <Box sx={styleSheet.headerContainer}>
      <FrameTop
        customStyle={{
          padding: "0",
          backgroundColor: "#171c66",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
          }}
        >
          {/* Left Side Header content */}
          <Box sx={styleSheet.homeV2}>
            {props.homeText && props.homeAction && (
              <HomeIconV2
                onHome={props.homeAction}
                title={props.homeText}
                enabled={props.homeButtonEnabled}
              />
            )}
          </Box>
          {(props.esLangText || props.enLangText) && props.LanguageSwitch && (
            <Box sx={styleSheet.LanguageSwitchContainerV2}>
              <Box style={{ display: "inline-block" }}>
                <Button
                  style={styleSheet.headerLinkV2}
                  variant="link"
                  id={isEnglish ? "en" : "es"}
                  onClick={() => {
                    props.LanguageSwitch?.action(isEnglish ? "es" : "en");
                    setIsEnglish(!isEnglish); // Toggle the language
                  }}
                >
                  {isEnglish ? (
                    <>
                      {props.LanguageSwitch.selectedLocale === "en" && (
                        <>
                          {props.esLangText}
                          <Box sx={styleSheet.langToggle}>
                            <Image
                              imgHeight={25}
                              imgWidth={40}
                              src={spanishIcon}
                            />
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {props.enLangText}
                      <Box sx={styleSheet.langToggle}>
                        <Image imgHeight={25} imgWidth={40} src={englishIcon} />
                      </Box>
                    </>
                  )}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
        <div style={styleSheet.connectionGroupWrapperV2}>
          <Box
            sx={styleSheet.connectionInfoV2}
            style={{
              backgroundColor: `${
                props.releaseVersion?.versionColors &&
                props.releaseVersion?.versionColors[
                  versionColorIndex(props.releaseVersion.version)
                ]
              }`,
              border: `1px solid ${
                props.releaseVersion?.versionBorderColors &&
                props.releaseVersion?.versionBorderColors[
                  versionColorIndex(props.releaseVersion.version)
                ]
              }`,
            }}
          >
            <div style={styleSheet.connectionType}>
              {props.connectionMode && (
                <Box sx={styleSheet.connectionContainer}>
                  {/* {props.connectionMode?.text} */}
                  {/* {props.connectionMode?.routerState} */}
                </Box>
              )}
            </div>
            {props.releaseVersion && <VersionV2 {...props.releaseVersion} />}
            <Box sx={styleSheet.iconsContainerV2}>
              {props.ConnectionState && (
                <ConnectionIcon state={props.ConnectionState} />
              )}
              {props.BatteryLevel && (
                <Box sx={{ display: "inline-block", verticalAlign: "bottom" }}>
                  <BatteryLevelIcon {...props.BatteryLevel} v2Check={true} />
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={styleSheet.exitButtonWrapperV2}>
            {props.exitAction && (
              <ExitIconV2
                onExit={props.exitAction}
                title={props.exitText  ?? "Exit"}
                enabled={props.exitButtonEnabled}
              />
            )}
          </Box>
        </div>
      </FrameTop>
    </Box>
  );
};
export default Header;
